import React from 'react';
import { Navigate, Routes, Route, NavLink } from 'react-router-dom';
import MainMenu from './components/MainMenu';
import MobileMenu from './components/MobileMenu';
import PackGrid from './components/PackGrid';
import RedeemPurchase from './components/RedeemPurchase';
import OrderConfirmed from './components/OrderConfirmed';
import Modal from "./components/Modal/Modal";
import { Footer } from './components/Footer';

import './App.css';
import ReactGA from 'react-ga4'
class App extends React.Component {
  state = { 
    modalIsShowing: true,  
    modalData: {},
    modalType: "",
  };

  componentDidMount() {
    ReactGA.send({ hitType: "pageview", page: window.location.pathname});
  }

  showModal = (type, data) => {
    this.setState({ modalIsShowing: true });
    this.setState({ modalType: type });
    this.setState({ modalData: data });
  };

  toggleModal = (e) => {
    this.setState({ modalIsShowing: !this.state.showModal });
  };

  hideModal = (e) => {
    this.setState({ modalIsShowing: false });
    this.setState({ modalData: {} });
    this.setState({ modalType: "" });
  };

  render() { 
    return (
    <>
      <div className="App">
        <MobileMenu showModal={this.showModal} toggleModal={this.toggleModal}/>
        <div className="main">
        <MainMenu showModal={this.showModal} toggleModal={this.toggleModal}/>
          <div id="main_area">
          <div id="content_loader" style={{paddingBottom:"2em"}}>
        <Routes>
          <Route exact path={"/"} element={<PackGrid showModal={this.showModal} toggleModal={this.toggleModal} />}
          />

          <Route exact path="/order-confirmed" element={<OrderConfirmed {...this.props} />} />

          <Route exact path="/redeem-purchase/:purchase_id/:security_key" element={<RedeemPurchase {...this.props} />} />

          <Route exact path="/pack-group/:pack_group" element={
            <>
              <PackGrid showModal={this.showModal} toggleModal={this.toggleModal} />
              <Modal {...this.props}
                type='pack-group'
                isShowing={this.state.modalIsShowing}
                hideModal={this.hideModal}
              />
            </>
            } 
          />

          <Route exact path="/news" element={
            <>
              <PackGrid showModal={this.showModal} toggleModal={this.toggleModal} />
              <Modal 
                type='news'
                isShowing={this.state.modalIsShowing}
                hideModal={this.hideModal}
              />
            </>
            }
          />

          <Route exact path="/subscribe" element={
            <div>
              <PackGrid showModal={this.showModal} toggleModal={this.toggleModal} />
          
              <Modal 
                type='subscribe'
                isShowing={this.state.modalIsShowing}
                hideModal={this.hideModal}/>
            </div>
            } 
          />

          <Route exact path="/about" element={
            <div>
            <PackGrid showModal={this.showModal} toggleModal={this.toggleModal} />
            <Modal 
              type='about'
              isShowing={this.state.modalIsShowing}
              hideModal={this.hideModal}
            />
            </div>
            }
          />

          <Route exact path="/contact" element={
            <div>
            <PackGrid showModal={this.showModal} toggleModal={this.toggleModal} />
            <Modal 
              type='contact'
              isShowing={this.state.modalIsShowing}
              hideModal={this.hideModal}
            />
            </div>
            }
          />
          <Route path="*" element={<Navigate to="/" />} />

          </Routes>
          
          </div>

          </div>

        </div>
      </div>
      <Footer showModal={this.showModal} toggleModal={this.toggleModal}/>
    </>
    );
  }
}

export default App;
